import { AuthorByline } from "@/components/site/AuthorByline";
import { personRef } from "@/content/author";
import { createFileRoute } from "@tanstack/react-router";
import bookCover from "@/assets/book-cover.webp";
import { hreflangLinks } from "@/lib/seo";
import { PageIntro, PageSection, Prose, MoreLink } from "@/components/site/page";

const CANONICAL = "https://akillisurdurulebilirlik.com/kitaplar/yapay-zeka-gucun-iki-yuzu";

const retailers = [
  { name: "Destek Dükkan", url: "https://destekdukkan.com/magaza/urun/yapay-zeka-gucun-iki-yuz", note: "Yayıncı resmi mağazası", primary: true },
  { name: "Amazon", url: "https://www.amazon.com.tr/s?k=Yapay+Zek%C3%A2+G%C3%BCc%C3%BCn+%C4%B0ki+Y%C3%BCz%C3%BC+Arda+%C3%96zta%C5%9Fk%C4%B1n", note: "Kargo + Kindle" },
  { name: "D&R", url: "https://www.dr.com.tr/kitap/yapay-zeka-gucun-iki-yuzu/arda-oztaskin/bilim/populer-bilim/urunno=0002137978001", note: "Mağaza & online" },
];

const toc: { part: string; chapters: string[] }[] = [
  { part: "Açılış", chapters: ["Teşekkür"] },
  {
    part: "Ön Yazılar",
    chapters: [
      "Yarıştan çekilip, anlama işini yapay zekâya mı bıraksak? — Günseli Özen",
      "Yapay zekâ insanlık ile neyin mübadelesini yapacak? — Salim Kadıbeşegil",
    ],
  },
  { part: "Giriş", chapters: ["İnsanlığın Karmaşık Müttefiki: Teknoloji"] },
  {
    part: "1 — Taş Devrinden Yapay Zekâ Çağına",
    chapters: [
      "İnsanın Teknolojik Evrimi",
      "Tarihin Dönüm Noktaları: İnsanlık ve Teknolojinin Kesişimi",
      "Tarım Devriminden Global Köye",
      "Yerleşik Yaşamın İlk Tohumları: Devrimlerin Beşiği",
      "Bilim Çağının Şafağı: Aydınlanma ve Rasyonel Düşüncenin Yükselişi",
      "Buharın Gücü: Sanayi Devriminin Yarattığı Dünya",
      "Dönüşüm Rüzgarları: İkinci Sanayi Devriminin Getirdikleri",
      "Fordist Devrim: Banttan Çıkan Hayatlar ve Toplumsal Değişim",
      "Sanayi Devriminin Cephe Hattı: Teknolojinin Askeri Yüzü",
      "Propagandanın Gücü: Medya, Politika ve Toplumsal Algı",
      "Savaş Sonrası Yeni Düzen",
      "Tarihten Derslerle Geleceği Kurgulamak",
    ],
  },
  {
    part: "2 — Siber Uygarlığın İnsanları: Dijital Çağda Yaşamak",
    chapters: [
      "Dijital Çağın İnsanı",
      "Dijital Devrimin Kıt Kaynağı: Dikkat",
      "Dijital Saplantı: Akıllı Telefonlar ve Bağlanma Kültürü",
      "Kaybolan Işık: Teknolojinin Gölgesinde İnsanlık",
      "Dijital Labirentten Çıkış Yolları",
      "Sanal Evcil Hayvanlardan Dijital Bağımlılığa",
      "Kontrolden Çıkan Büyü: Mistik Geçmişten Dijital Geleceğe",
      "Bir Chatbot'a Aşık Olmak: Dijital Çağda Duygusal İlişkiler",
      "Teknoloji ile Gerçekleşen Distopya: Çin'in Gözetim Toplumu",
      "Robotlar, Yapay Zekâ ve Sinema: Kurgudan Gerçeğe",
      "Deepfake ve Dijital Dezenformasyon",
      "Teknoloji Çağında Gerçeklik Savaşı: Yalan ile Mücadele",
      "Lambadan Çıkan Cin: Yapay Zekâ",
      "İnsan ile Makine Arasındaki Çizgi: Bilinç",
      "Teknolojiyle Yeniden Tanımlanan Sanat",
      "Teknolojinin Bakım Kahramanları: Robot Hemşireler",
      "'Sürdürülebilir Büyüme' Oksimoron mu?",
      "Çevresel Ekonominin İtici Gücü: Yeşil Algoritmalar",
      "Yapay Zekâ ile İklim Krizine Meydan Okumak",
      "Sağlıkta Yapay Zekâ Devrimi",
      "Beynin Sınırlarını Aşmak: Nörobilim ve Yapay Zekâ ile Dönüşüm",
      "Tekillik, Yapay Genel Zekâ ve Transhümanizm: İnsanlığın Geleceği Yeniden Yazılıyor",
      "Toparlarsak…",
    ],
  },
  {
    part: "Son Yazı",
    chapters: ["Yapay zekâ çağında hangisinin kaderini yaşayacağız? Atların mı yoksa otomobillerin mi? — M. Serdar Kuzuloğlu"],
  },
  { part: "Kapanış", chapters: ["Akılda Ne Kalsın", "Kaynakça"] },
];

const quotes: { text: string; page?: string }[] = [
  {
    text: "Zekâsıyla dünyanın efendisi olan insandan daha zeki bir şeyin varlığında insanın varlığı ne ifade edecek? Bu kitapta yapay zekâ uzmanlarından çok filozofların isimlerinin yer almasının sebebi de bu.",
    page: "M. Serdar Kuzuloğlu",
  },
];

const press: { outlet: string; title: string; url: string; date?: string }[] = [
  { outlet: "YouTube", title: "Arda Öztaşkın ile söyleşi — Yapay Zekâ: Gücün İki Yüzü", url: "https://www.youtube.com/watch?v=nPbiZUZAPYY" },
  { outlet: "Marketing Türkiye", title: "Arda Öztaşkın'ın yeni kitabı 'Yapay Zekâ: Gücün İki Yüzü' yayınlandı", url: "https://www.marketingturkiye.com.tr/haberler/arda-oztaskinin-yeni-kitabi-yapay-zeka-gucun-iki-yuzu-yayinlandi/" },
  { outlet: "TEGV", title: "Arda Öztaşkın'ın yeni kitabının geliri TEGV'e", url: "https://tegv.org/arda-oztaskinin-yeni-kitabinin-geliri-tegve" },
];

export const Route = createFileRoute("/kitaplar/yapay-zeka-gucun-iki-yuzu")({
  head: () => ({
    meta: [
      { title: "Yapay Zekâ: Gücün İki Yüzü — Arda Öztaşkın" },
      {
        name: "description",
        content: "Yapay zekâ çağında insanlık keskin bir virajda. Arda Öztaşkın'ın kitabı: içindekiler, alıntılar, basın yansımaları ve satın alma linkleri.",
      },
      { property: "og:title", content: "Yapay Zekâ: Gücün İki Yüzü — Arda Öztaşkın" },
      { property: "og:description", content: "İçindekiler, alıntılar, basın ve satın alma linkleri." },
      { property: "og:type", content: "book" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: CANONICAL },
    ],
    links: [
      { rel: "canonical", href: CANONICAL },
      ...hreflangLinks("/kitaplar/yapay-zeka-gucun-iki-yuzu"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Book",
          name: "Yapay Zekâ: Gücün İki Yüzü",
          inLanguage: "tr",
          author: personRef(),
          image: `https://akillisurdurulebilirlik.com${bookCover}`,
          url: CANONICAL,
          datePublished: "2024",
          publisher: { "@type": "Organization", name: "Destek Yayınları" },
          workExample: {
            "@type": "Book",
            bookFormat: "https://schema.org/Paperback",
            inLanguage: "tr",
            publisher: { "@type": "Organization", name: "Destek Yayınları" },
            potentialAction: { "@type": "ReadAction", target: retailers.map((r) => r.url) },
          },
          offers: retailers.map((r) => ({
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            priceCurrency: "TRY",
            url: r.url,
            seller: { "@type": "Organization", name: r.name },
          })),
        }),
      },
    ],
  }),
  component: BookPage,
});

function Cover() {
  return (
    <img
      src={bookCover}
      alt="Yapay Zekâ: Gücün İki Yüzü — Arda Öztaşkın kitap kapağı"
      width={400}
      height={600}
      loading="lazy"
      decoding="async"
      className="aspect-[2/3] w-full max-w-[200px] object-cover shadow-sm lg:max-w-[280px]"
    />
  );
}

function BookPage() {
  return (
    <div>
      <PageIntro
        crumbs={[{ label: "Kitaplar", to: "/kitaplar" }, { label: "Yapay Zekâ: Gücün İki Yüzü" }]}
        kicker="Kitap · 2024"
        dot="bg-theme-tech"
        title={<>Yapay Zekâ: <em className="italic">Gücün İki Yüzü</em></>}
        lede="Yapay zekâ çağında, insanlık tarihi ya bizim kontrolümüzde devam edecek ya da gelişkin yapay zekâ teknolojileriyle sürüklenecek. Tercih yine bizde, insanın kendisinde…"
        aside={<Cover />}
      >
        <AuthorByline />
        <div className="mt-5 lg:hidden"><Cover /></div>
      </PageIntro>

      <PageSection title="Kitap hakkında">
        <Prose>
          <p>
            İnsanlık olarak keskin bir yapay zekâ virajındayız. Bu, daha önceki hiçbir teknolojik kırılmaya
            benzemiyor. Bu virajı nasıl alacağımız tüm insanlık adına belirleyici olacak.
          </p>
          <p>
            Felaket senaryolarını ortaya atmak kolay ama esas mesele yapay zekâ çağında bu yeni teknolojik gelişmeleri
            fırsat olarak görmekten geçiyor. Elbette tüm tartışmanın merkezine ortak fayda, etik, ahlak, vicdan,
            adalet gibi son derece kritik kavramları koyarak. Ve yine bu konuda kendi sorumluluklarımızın da farkında
            olarak...
          </p>
        </Prose>
      </PageSection>

      <PageSection title="İçindekiler">
        <div className="grid gap-7 sm:grid-cols-2">
          {toc.map((part) => (
            <div key={part.part} className="space-y-2">
              <h3 className="font-serif text-base text-ink/85">{part.part}</h3>
              <ul className="list-decimal space-y-1 pl-5 text-sm leading-relaxed text-ink/75 marker:text-ink/30">
                {part.chapters.map((c) => <li key={c}>{c}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </PageSection>

      <PageSection title="Alıntılar">
        <div className="space-y-6">
          {quotes.map((q, i) => (
            <blockquote key={i} className="border-l-2 border-theme-tech pl-5 font-serif text-lg italic leading-relaxed text-ink/85">
              "{q.text}"
              {q.page && <footer className="mt-2 text-xs not-italic text-ink/60">— {q.page}</footer>}
            </blockquote>
          ))}
        </div>
      </PageSection>

      <PageSection title="Basında">
        <ul className="space-y-4">
          {press.map((p) => (
            <li key={p.url}>
              <MoreLink href={p.url}>{p.title}</MoreLink>
              <p className="mt-1 text-xs text-ink/60">{p.outlet}{p.date ? ` · ${p.date}` : ""}</p>
            </li>
          ))}
        </ul>
      </PageSection>

      <PageSection title="Satın al">
        <div className="flex flex-wrap gap-3">
          {retailers.map((r) => (
            <a
              key={r.name}
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex min-h-11 items-center gap-2 rounded-full border px-4 text-sm ${r.primary ? "border-ink bg-ink text-paper" : "border-ink/20 text-ink/80 hover:border-ink"}`}
            >
              {r.name} <span className="text-xs opacity-70">{r.note}</span>
            </a>
          ))}
        </div>
      </PageSection>

      <PageSection>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-serif text-lg">İngilizce versiyonu için</p>
          <a
            href="https://www.amazon.com/dp/B0H58HHS3B/?_encoding=UTF8&pd_rd_w=A2WnM&content-id=amzn1.sym.3a079c4e-f938-40c9-a0ed-01ef0e9528e9&pf_rd_p=3a079c4e-f938-40c9-a0ed-01ef0e9528e9&pf_rd_r=136-7611256-5080460&pd_rd_wg=sEV3Y&pd_rd_r=0d459c8e-850d-43b7-bc7b-b0f4d658e5f0"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-11 items-center justify-center rounded-full border border-ink/20 px-5 text-sm hover:border-ink transition-colors"
          >
            Amazon'da görüntüle
          </a>
        </div>
      </PageSection>

      <PageSection>
        <p className="text-sm text-ink/70">Yayıncı</p>
        <p className="mt-1 font-serif text-lg">Destek Yayınları</p>
        <div className="mt-3"><MoreLink to="/">Ana sayfaya dön</MoreLink></div>
      </PageSection>
    </div>
  );
}
